import { render, staticRenderFns } from "./ForceProfile.vue?vue&type=template&id=22b711f4&"
import script from "./ForceProfile.vue?vue&type=script&lang=js&"
export * from "./ForceProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports